"use client";

import { useEffect, useState } from "react";
import { mainMenuItemClass } from "./mainMenuStyles";

const SKIPPED_KEY = "cloudaxe-intro-skipped";
const VIEWS_KEY = "cloudaxe-intro-views";
const MAX_INTRO_VIEWS = 5;

/**
 * Replay link for the intro landing page. Only shown after the visitor has
 * skipped the intro or exhausted the free view count. Mounts only after a
 * client localStorage read to avoid hydration mismatch.
 *
 * Uses a plain <a> (not next/link) because /landing.html is a static nginx
 * file outside the Next.js app router.
 */
export function WatchOurStoryLink({ className }: { className?: string }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const skipped = localStorage.getItem(SKIPPED_KEY) === "1";
      const views = parseInt(localStorage.getItem(VIEWS_KEY) || "0", 10) || 0;
      if (skipped || views >= MAX_INTRO_VIEWS) {
        setVisible(true);
      }
    } catch (error) {
      console.error("WatchOurStoryLink: failed to read intro state", error);
    }
  }, []);

  if (!visible) return null;

  return (
    <a
      href="/landing.html"
      className={className ?? mainMenuItemClass(false)}
    >
      Watch our story
    </a>
  );
}
